import React from 'react';

import {Spinner} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

import {Pagination} from 'react-bootstrap';

const ComponentPagination = props => {

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div className="py-1 py-md-0">
            <Pagination className="mb-0 mt-md-5 justify-content-center">
                <Pagination.Item disabled={props.pagination === 1 || props.paginationDisabled} className={`arrow${props.pagination === 1 ? ' invisible' : ''}`} onClick={() => props.onClick(1)}>
                    <IconFi.FiChevronRight size={24} className="sw-1"/>
                </Pagination.Item>
                {
                    Array.from({length: props.totalPages}).map((_, index) => {
                        return (
                            <Pagination.Item disabled={props.paginationDisabled && props.pagination !== (index + 1)} active={props.pagination === (index + 1)} onClick={() => {props.pagination !== (index + 1) && props.onClick(index + 1)}} className="btn-loading" key={index}>
                                <Spinner as="i" animation="border" size="sm" className={`border-1${props.paginationDisabled && props.pagination === (index + 1) ? ' opacity-100' : ''}`}/>
                                <span className="lh-0">{index + 1}</span>
                            </Pagination.Item>
                        )
                    })
                }
                <Pagination.Item disabled={props.pagination === props.totalPages || props.paginationDisabled} className={`arrow${props.pagination === props.totalPages ? ' invisible' : ''}`} onClick={() => props.onClick(props.totalPages)}>
                    <IconFi.FiChevronLeft size={24} className="sw-1"/>
                </Pagination.Item>
            </Pagination>
        </div>
    )
}

export default ComponentPagination;